import { render, staticRenderFns } from "./QuestionTypeModal.vue?vue&type=template&id=948b0b00&"
import script from "./QuestionTypeModal.vue?vue&type=script&lang=js&"
export * from "./QuestionTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports